var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.7,
    height: 21.688,
    viewBox: "0 0 21.7 21.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_photos_785766",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M23.465,6.585,17.182,3.33V2.536a.435.435,0,0,0-.436-.436H2.436A.438.438,0,0,0,2,2.536V23.352a.435.435,0,0,0,.436.436h14.31a.435.435,0,0,0,.436-.436V19.67l6.472-12.5A.439.439,0,0,0,23.465,6.585ZM15.012,19.452h0a5.421,5.421,0,1,0-10.842,0h0V4.27H15.012Zm2.17-4.511V5.782l3.738,1.935Z",
    transform: "translate(-2 -2.1)",
    fill: "#05cb24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M131.07,133.34a2.17,2.17,0,1,0-2.17-2.17A2.17,2.17,0,0,0,131.07,133.34Z",
    transform: "translate(-123.479 -123.579)",
    fill: "#05cb24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.79065d2d2fac596a0a2302805fcad407.svg";
export { ForwardRef as ReactComponent };